import React from "react";
import RaffleCookiePolicy from "./RaffleCookiePolicy";
import RafflePrivacyPolicy from "./RafflePrivacyPolicy";
import RaffleTermsAndConditionsModal from "./RaffleTermsAndConditionsModal";
import { Link } from "react-router-dom";
import {
  currencyCodes,
  isTabletView,
  trimTrailingSlash,
} from "../../../lib/utils";

const currentYear = new Date().getFullYear();

export default class RaffleNavBar extends React.PureComponent {
  render() {
    const {
      homeUrl,
      pathname,
      raffleEnrollment,
      sellerId,
      showTermsAndConditions,
      termsAndConditions,
      toggleShowTermsAndConditions,
    } = this.props;

    const {
      currencyCode,
      fullLegalText,
      shortLegalText,
      shortUkLegalText,
      chabadHouseWebsiteURL,
      chabadHouseLogoURL,
      chabadHouseFacebookURL,
      chabadHouseTwitterURL,
      chabadHouseInstagramURL,
    } = raffleEnrollment || {};

    const hideInfoFooter = pathname?.includes("/purchase-complete");
    const shortChabadHouseURL = trimTrailingSlash(
      chabadHouseWebsiteURL
        ?.replace(/^https?:\/\/|^http?:\/\//, "")
        .replace(/www./, "")
    );
    return (
      !hideInfoFooter && (
        <div className="info-footer">
          <div className="container">
            <div
              className="flex flex-justify-space tablet-flex-column-reverse"
              style={{ gap: 32 }}
            >
              <div style={{ maxWidth: 872, flex: 1 }}>
                <div
                  className="flex flex-justify-space flex-align-center mb-32 mobile-block mobile-text-center mobile-mt-24"
                  style={
                    isTabletView()
                      ? {
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }
                      : {}
                  }
                >
                  <div>
                    <p className="fs-22 light-text mb-16">
                      Contact Customer Support
                    </p>
                    <p className="accent-color-text fs-24 fw-700 mb-16 flex mobile-flex-column">
                      {currencyCode === currencyCodes.GBP ? (
                        <a className="pointer" href="tel:+44-20-80898181">
                          02080898181
                        </a>
                      ) : (
                        <a className="pointer" href="tel:+1-718-510-8181,0">
                          718 510 8181 x 0
                        </a>
                      )}
                      <span className="ml-8 mr-8 mobile-hidden">|</span>
                      <a
                        className="mobile-mt-8"
                        href="mailto:help@chabadoncampus.org"
                        rel="noopener noreferrer"
                      >
                        help@chabadoncampus.org
                      </a>
                    </p>
                  </div>
                  <Link
                    to={`${trimTrailingSlash(homeUrl)}/faq`}
                    className="btn btn-rounded btn-rounded-outline"
                  >
                    View FAQs
                  </Link>
                </div>
                <div className="legal-text">
                  <p className="line-height-double">
                    {currencyCode === currencyCodes.GBP
                      ? shortUkLegalText
                      : shortLegalText}
                  </p>
                  <p className="mt-24 mb-32">
                    <span
                      className="fw-700 accent-color-text uppercase-text pointer"
                      style={{ letterSpacing: 2 }}
                      onClick={(evt) =>
                        toggleShowTermsAndConditions(
                          evt,
                          termsAndConditions.legalText
                        )
                      }
                    >
                      View Full Terms & Conditions
                    </span>
                  </p>
                  <RaffleTermsAndConditionsModal
                    close={toggleShowTermsAndConditions}
                    show={!!showTermsAndConditions}
                    termsAndConditions={
                      showTermsAndConditions ===
                      termsAndConditions.cookiePolicy ? (
                        <RaffleCookiePolicy />
                      ) : showTermsAndConditions ===
                        termsAndConditions.privacyPolicy ? (
                        <RafflePrivacyPolicy />
                      ) : (
                        fullLegalText
                      )
                    }
                    title={
                      showTermsAndConditions === termsAndConditions.cookiePolicy
                        ? "Cookie Policy"
                        : showTermsAndConditions ===
                          termsAndConditions.privacyPolicy
                        ? "Privacy Policy"
                        : "Terms and Conditions"
                    }
                  />
                </div>
                <p className="copyright-text">
                  © {currentYear} Chabad on Campus. All rights reserved.
                </p>
              </div>
              {sellerId ? (
                <div className="flex flex-column flex-align-center">
                  <div className="logo-container">
                    <img
                      src={chabadHouseLogoURL || "/images/chabad-logo.svg"}
                      alt="logo"
                      width="200"
                    />
                  </div>
                  <a
                    href={chabadHouseWebsiteURL}
                    className="fs-24 fw-700 accent-color-text pointer block text-center"
                  >
                    {shortChabadHouseURL}
                  </a>
                  {(chabadHouseFacebookURL ||
                    chabadHouseTwitterURL ||
                    chabadHouseInstagramURL) && (
                    <div>
                      <p className="fw-700 mt-24 mb-24 brand-color-text">
                        Follow us on Social Media
                      </p>
                      <div className="social-links-icons">
                        {chabadHouseFacebookURL && (
                          <div className="social-links-icon">
                            <a
                              href={chabadHouseFacebookURL}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src="/images/facebook-icon.svg"
                                alt="facebook"
                              />
                            </a>
                          </div>
                        )}
                        {chabadHouseTwitterURL && (
                          <div className="social-links-icon">
                            <a
                              href={chabadHouseTwitterURL}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src="/images/x-twitter-icon.svg"
                                alt="x (twitter)"
                              />
                            </a>
                          </div>
                        )}
                        {chabadHouseInstagramURL && (
                          <div className="social-links-icon">
                            <a
                              href={chabadHouseInstagramURL}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                src="/images/instagram-icon.svg"
                                alt="instagram"
                              />
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="flex flex-column flex-align-center">
                  <div className="flex fw-300 sellers-link">
                    <a href={`${window.location.origin}/sellers`}>
                      Grand Draw Seller List
                    </a>
                    <p className="ml-8 mr-8">&#124;</p>
                  </div>

                  <img src="/images/chabad-logo.svg" alt="logo" />
                  <a
                    href="/"
                    className="fs-24 fw-700 accent-color-text pointer"
                  >
                    granddraw.org
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      )
    );
  }
}
